import { ExternalLinkIcon } from '@chakra-ui/icons'
import { Link as ChakraLink, LinkProps } from '@chakra-ui/react'

export function Link ({ children, ...rest }: LinkProps) {
  return (
    <ChakraLink
      // color="whiteAlpha.700"
      color="rgb(55 150 255)"
      fontWeight="600"
      {...rest}
    >
      {children}
      {rest.isExternal && (
        <ExternalLinkIcon
          mx='2px'
          verticalAlign="baseline"
        />
      )}
    </ChakraLink>
  )
}
